import {useIonToast} from "@ionic/react";

import './useToasts.css'

export const useToast = () => {
    const [present] = useIonToast();

    const showToasts = (message: string, color: string) => {
        present({
            message,
            duration: 1000,
            position: "top",
            color,
            cssClass: "toast-top-right"
        })
    }
    return showToasts;
}
